module.exports = __webpack_public_path__ + "img/proteinasImage.eef96965.svg";